







































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TitleArea from '@/components/TitleArea.vue';
import validations from "@/plugins/validations";
import { UtenteForm, newUtenteServer } from "@/plugins/utils/utentesUtils";

@Component({
  components: {
    TitleArea
  }
})
export default class Consulta extends Vue {
  primaryColor = this.$vuetify.theme.themes.light.primary;
  formValid = false;
  validations = validations;
  utente: UtenteForm = {id: null, nome: "", telefone: "", codigo: "", observacoes: ""};

  saveAction(): void {
    this.$store.commit("setError", {flag: false, text: "", status: "error"});
    const formValid = (this.$refs.utenteForm as Vue & { validate: () => boolean }).validate();
    if(formValid){
      this.callServer();
    } else {
      this.$store.commit("setError", {flag: true, text: "Preencha todos os campos obrigatórios!", status: "error"});
    }
  }

  callServer(): void {
    this.$store.commit("setLoading", true);
    newUtenteServer(
      this.utente,
      () => {
        this.$store.commit("setError", {flag: true, text: "Utente inserido com sucesso!", status: "success"});
        this.$router.push("/utentes");
      },
      () => {
        this.$store.commit("setError", {flag: true, text: "Ocorreu um erro ao inserir no servidor...", status: "error"});
        this.$store.commit("setLoading",false);
      }
    );

  }
}
